import React, {Component} from 'react';
import { DropTarget } from 'react-dnd';
import classnames from 'classnames';
import { CategoryTypes } from "../../constants/category/DragAndDropTypes";
import RootNode from "./RootNode";
import DragNode from "./DragNode";
import CategoryNode from "./CategoryNode";
import { connect } from 'react-redux'
import { openAllSubCategory, closeAllSubCategory, appendAtRootCategory, updateCategoryTree } from '../../actions/category'
import { MAXIMUM_NODE_COUNT } from "../../constants/category/CategoryLimit";

function CategoryAddButton(props) {
  const { totalCount, onAdd } = props;

  if (totalCount < MAXIMUM_NODE_COUNT) {
    return (
      <div className="wrap_add">
        <label className="lab_btn lab_add">
          <span className="ico_blog ico_add"/>
          카테고리 추가
          <input type="button" className="btn_g" value="카테고리 추가" onClick={onAdd} />
        </label>
        <span className="count_total">
            <span className="screen_out">카테고리 개수</span>
            <span className="txt_num">{totalCount}</span> / {MAXIMUM_NODE_COUNT}
        </span>
      </div>
    );
  } else {
    return (
      <div className="wrap_add">
        <p className="item_noti">
          <span className="wrap_ico"><span className="ico_blog"/></span>더 이상 카테고리를 추가할 수 없습니다.
        </p>
      </div>
    );
  }
}


@connect(state => ({
  categoryTree: state.category.categoryTree,
  viewChannels: state.category.viewChannels,
  nodeCount : state.category.nodeCount,
}), dispatch => ({
  handleAppendAtRootCategory: () => {
    dispatch(appendAtRootCategory())
  },
  handleOpenAllSubCategory: () => {
    dispatch(openAllSubCategory())
  },
  handleCloseAllSubCategory: () => {
    dispatch(closeAllSubCategory())
  },
  handleUpdateCategoryTree: (categoryTree) => {
    dispatch(updateCategoryTree(categoryTree))
  },
  dispatch
}))
@DropTarget(CategoryTypes.NODE, {
}, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))
class CategoryPanel extends Component {

  render() {
    const { nodeCount, categoryTree } = this.props;
    const { isOver, connectDropTarget } = this.props;
    const { viewChannels } = this.props;
    const { handleAppendAtRootCategory } = this.props;

    return connectDropTarget(
      <div className={classnames('set_order', {'on_order': isOver})} id="category-app">
        <div className="wrap_order">
          <div className="list_order">
            <DragNode viewChannels={viewChannels}/>
            <RootNode/>
            {categoryTree && categoryTree.map((category, i) =>
              <CategoryNode category={category} parent={null} index={i} key={category.id} hasChild={(category.children && category.children.length > 0)}>
                {category.children && (category.children.length > 0) && category.opened &&
                  <div className="list_sub">
                    {category.children.map((subCategory, j) =>
                      <CategoryNode category={subCategory} key={subCategory.id} parent={category} index={j} hasChild={false}/>
                    )}
                  </div>
                }
              </CategoryNode>
            )}
          </div>
          <CategoryAddButton
            totalCount={nodeCount}
            onAdd={handleAppendAtRootCategory}
          />
        </div>
      </div>
    )
  }
}

export default CategoryPanel;
